import styled from 'styled-components';
import { getBaseTheme } from '@Themes';

const { texts, spaces } = getBaseTheme();

export const ClauseTextWrapper = styled.div`
    margin: ${spaces.default.xs} 0;
    line-height: ${texts.sizes.xs.lineHeight};
`;

export const ClauseSummaryCardWrapper = styled.div`
    margin-bottom: 1.2rem;
    width: 100%;
    height: 100%:
`;

export const ClauseDetailsButton = styled.button`
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    font-size: ${texts.sizes.s.fontSize};
    letter-spacing: ${texts.sizes.s.letterSpacing};
    line-height: ${texts.sizes.s.lineHeight};
    font-weight: 600;
    font-family: inherit;
    text-align: left;

    &:hover {
        text-decoration: underline;
    }

    &.show-fallback {
        font-size: ${texts.sizes.xs.fontSize};
        letter-spacing: ${texts.sizes.xs.letterSpacing};
        line-height: ${texts.sizes.xs.lineHeight};
        font-weight: 400;
        margin-left: 1.8rem;
        color: rgb(17, 16, 25, 0.4);
    }
`;

export const Tags = styled.p`
    color: #0168fe;
    margin: 0;
`;

export const Dot = styled.span({
    height: 7,
    width: 7,
    backgroundColor: '#0070fa',
    borderRadius: '50%',
    display: 'inline-block',
    marginLeft: 4
});

export const TitleDotContainer = styled.div({
    display: 'flex',
    alignItems: 'center'
});
